<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Seguimiento de productos por compras
    </h2>
    <MainProductsBySupplier />
  </div>
</template>

<script>
import MainProductsBySupplier from "@/components/Reports/ProductsBySupplier/MainProductsBySupplier.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ProductsBySupplier",
  components: {
    MainProductsBySupplier,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
